import { makeStyles } from "@mui/styles";

export const contactSection = makeStyles(() => ({
    container: {
        marginTop: 30,
        paddingLeft: 20,
        paddingRight: 20,
        width: "100%",
    },
    contactListContainer: {
        marginBottom: 8,
        maxHeight: 500,
        overflow: "scroll",
        overflowX: "hidden",
    },
    addIconButton: {
        width: 35,
        minWidth: 35,
        height: 35,
        minHeight: 35,
    },
    editButton: {
        
        float: "right",
        marginRight: 10,
    },
    deleteButton: {
        color: "#DE350B",
        borderColor: "#DE350B",
        
        float: "right",
        marginRight: 10,
    },
    deleteButtonConfirm: {
        color: "#DE350B",
        borderColor: "#DE350B",
    },
    listItemContainer: {
        marginRight: 10,
    },
    scroll: {
        "&::-webkit-scrollbar-track": {
            WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
            borderRadius: "10px",
            backgroundColor: "#F5F5F5",
        },
        "&::-webkit-scrollbar": { width: "6px", backgroundColor: "#F5F5F5" },
        "&::-webkit-scrollbar-thumb": {
            borderRadius: "10px",
            WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
            backgroundColor: "#90a0f8",
        },
    },
}));
